'use client';

import React from 'react';
import { Box, VStack } from '@skin-seoul/design-system';
export interface DropdownContainerProps {
  children: React.ReactNode;
  isOpen?: boolean;
  maxHeight?: string;
}
const DropdownContainer = ({
  children,
  isOpen = false,
  maxHeight = '200px'
}: DropdownContainerProps) => {
  if (!isOpen) {
    return null;
  }
  return <Box position="absolute" top="100%" left={0} right={0} zIndex="dropdown" backgroundColor="white" border="1px solid" borderColor="neutral.100" borderRadius="0 0 8px 8px" boxShadow="0 10px 15px -3px rgba(0, 0, 0, 0.08)" maxHeight={maxHeight} overflowY="auto" marginTop="-1px" data-sentry-element="Box" data-sentry-component="DropdownContainer" data-sentry-source-file="DropdownContainer.tsx">
      <VStack gap={0} width="100%" alignItems="stretch" data-sentry-element="VStack" data-sentry-source-file="DropdownContainer.tsx">
        {children}
      </VStack>
    </Box>;
};
export default DropdownContainer;